import { Delete } from "lucide-react";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "00", "0", "back"];

export default function Keypad({ onKey }) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {KEYS.map((k) => (
        <button
          key={k}
          type="button"
          data-testid={`keypad-${k}`}
          onClick={() => onKey(k)}
          className="h-14 sm:h-16 text-xl sm:text-2xl mono font-bold rounded-xl border border-[#222B3D] bg-[#111622] hover:bg-[#1E293B] active:scale-95 transition-all text-slate-100 flex items-center justify-center select-none"
        >
          {k === "back" ? <Delete className="h-6 w-6" /> : k}
        </button>
      ))}
    </div>
  );
}

export function applyKey(value, k) {
  if (k === "back") return value.slice(0, -1);
  if (k === "00" || k === "000") return value === "" ? value : value + k;
  return value + k;
}
